<template>
  <With_Header_Modal_Template title="Фильтры" withoutFooter>
    <div class="mobile__filters">
      <template v-if="modalDataModal.page === 'master'">
        <custom-select v-if="!!orders && filter.order" @change="(order) => filter.order = order" :value="filter.order" width="100%">
          <option v-for="order in orders" :key="order.value" :value="order.value">{{ order.name }}</option>
        </custom-select>
        <custom-select width="100%" mt="15px" @change="(city_id) => filter.city_id = city_id" :value="filter.city_id">
          <option value="">Выберите город</option>
          <option v-for="city in getCities" :key="city.id" :value="city.id">{{ city.name }}</option>
        </custom-select>
        <custom-select
            v-if="!!specializations"
            @change="(specialization) => filter.specialization = specialization"
            :value="filter.specialization"
            width="100%"
            mt="15px"
        >
          <option value="">Выберите специализацию</option>
          <option
              :selected="filter.specialization == specialization.id"
              v-for="specialization in specializations"
              :key="specialization.id"
              :value="specialization.id">
            {{ specialization.name }}
          </option>
        </custom-select>
        <div class="cbx_mt">
          <custom-checkbox
              id="withPortfolio"
              v-model="filter.portfolio"
          >Только с портфолио
          </custom-checkbox>
        </div>
        <div class="button_bottom">
          <ButtonComponent variant="filled" width="100%" @click="save()">Сохранить</ButtonComponent>
        </div>
      </template>


      <template v-else-if="modalDataModal.page === 'coworking'">
        <custom-select width="100%">
          <option value="v" selected>По рейтингу</option>
        </custom-select>
        <custom-select width="100%" mt="15px">
          <option value="v" selected>Москва</option>
        </custom-select>
        <custom-select width="100%" mt="15px">
          <option value="v" selected>Москва</option>
        </custom-select>
        <div class="button_bottom">
          <ButtonComponent variant="filled" width="100%">Сохранить</ButtonComponent>
        </div>
      </template>
    </div>
  </With_Header_Modal_Template>
</template>

<script>
import With_Header_Modal_Template from '@/components/Modals/ModalsTemplate/With_Header_Modal_Template'
import CustomSelect from '@/components/ui/inputs/custom-select'
import ButtonComponent from '@/components/ui/buttons/button-component'
import {mapGetters, mapMutations} from 'vuex'
import CustomCheckbox from '@/components/ui/inputs/custom-checkbox'

export default {
  name: "MobileFilters",
  components: {CustomCheckbox, ButtonComponent, CustomSelect, With_Header_Modal_Template},
  computed: {
    ...mapGetters(['modalDataModal', 'getCities'])
  },
  mounted() {
    this.filter = this.modalDataModal.filter;
    this.orders = this.modalDataModal.orders;
    this.specializations = this.modalDataModal.specializations;
  },
  data: () => ({
    filter: {},
    portfolio: true,
    orders: [],
    specializations: [],
  }),
  methods: {
    ...mapMutations(['closeModals']),
    save() {
      this.$eventHub.$emit('master.filters.changed', this.filter);
      setTimeout(() => this.closeModals(), 100);
    }
  },
}
</script>

<style scoped lang="scss">
.mobile__filters {
  padding: 20px 15px;
  padding-bottom: 80px;
  position: relative;
  height: 100%;
}

.button_bottom {
  position: absolute;
  bottom: 20px;
  left: 15px;
  right: 15px;
}

.cbx_mt {
  margin-top: 20px;
}
</style>
